import { get, post } from './utils';

export async function importLocationStocksApi(data) {
  return post(`/location-stocks/import`, data);
}

export async function getJobStatusApi(id) {
  return get(`/batch/job-status/${id}`);
}

export async function getSummaryInventoriesApi() {
  return get(`/inventories/summary/stock`);
}
